import { Component, signal , Injector, inject, untracked, effect, runInInjectionContext} from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { SideBarComponent } from '../side-bar/side-bar.component';
import { Router , RouterLink, RouterOutlet } from '@angular/router';
import {MatSidenavModule} from '@angular/material/sidenav';
import { CommonModule } from '@angular/common';
import {MediaMatcher} from '@angular/cdk/layout';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {configStore} from '../../../stores/config.store';
import {projectStore} from '../../../stores/project.store';
import { ProjectServices } from '../../../models/project.model';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-main',
  imports: [CommonModule, MatSidenavModule, HeaderComponent, SideBarComponent, RouterOutlet, RouterLink, MatIconModule, MatButtonModule],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class AppMainComponent {
   private router = inject(Router);
   private titleService = inject(Title);
protected readonly isMobile = signal(true);
//private readonly _mobileQueryListener: () => void;
//private readonly _mobileQuery: MediaQueryList;
configStore = inject(configStore);
projectStore = inject(projectStore);
projects = this.projectStore.projects
project = this.configStore.currentProject;
env = this.configStore.currentEnv;
connectError = this.configStore.connectError;
// Service tabs (/{service}/{project}/{env}) must connect to the env's instance; /projects does not
isServiceTab = signal(false);
private connectStarted = false;
  
constructor(private injector: Injector) {
  const media = inject(MediaMatcher);

  //this._mobileQuery = media.matchMedia('(max-width: 800px)');
  //this.isMobile.set(this._mobileQuery.matches);
  //this._mobileQueryListener = () => this.isMobile.set(this._mobileQuery.matches);
  //this._mobileQuery.addEventListener('change', this._mobileQueryListener);

  const currentUrl = this.router.url;
  const initialService = (currentUrl.split('/')[1] || '').replace('eru','eru-');
  const initialProject = currentUrl.split('/')[2] || '';
  const initialEnv = currentUrl.split('/')[3] || '';
  if (initialService !== '') {
    this.configStore.setCurrentService(initialService);
  }

  
  if (initialProject !== '' && initialEnv !== '') {
    this.configStore.setCurrentProjectEnv(initialProject, initialEnv);
  }
  this.isServiceTab.set(initialService !== '' && initialService !== 'projects');
  this.configStore.setConnectError('');

  window.onbeforeunload = () => {
    // Handle reload here
    //this.router.navigate(['/eruauth/devapps/dev']);
  };
}

ngOnInit() {
    this.projectStore.fetchProjects(this.project(), this.env());
        
    // Use runInInjectionContext to create an effect in ngOnInit
    runInInjectionContext(this.injector, () => {
     // Use effect to watch the status signal
     effect(() => {
       // Get the current status
       const status = this.projectStore.projectsResource.status();
       
       if (status === 'resolved') {
         // Only process when the resource has successfully loaded
         const currentProjects = this.projects();
         
         if (currentProjects && currentProjects.length > 0) {
           // Use untracked to avoid creating a dependency on the projects signal
           untracked(() => {
             this.processProjectsAndLogin(currentProjects);
           });
         } else if (currentProjects && this.isServiceTab()) {
           untracked(() => this.configStore.setConnectError(`Project "${this.project()}" was not found or you have no access to it.`));
         }
       }
     });
    });


    runInInjectionContext(this.injector, () => {
      effect(() => {
        const projectName = this.project();
        const envName = this.env();
        if (!projectName || !envName) return;
        const title = `eru (${projectName} - ${envName})`;
        this.titleService.setTitle(title);
      });
    });
  }

  private async processProjectsAndLogin(currentProjects: any[]) {
    if (!this.isServiceTab()) {
      this.configStore.setMainLoaded(true);
      return;
    }
    // fetchProjects re-resolves the resource; connect only once per tab
    if (this.connectStarted) return;
    this.connectStarted = true;

    const projectName = safeDecode(this.configStore.currentProject());
    const envName = safeDecode(this.configStore.currentEnv());
    const project = currentProjects.find((p: any) => p.project_name === projectName);
    const env = project?.public___project_envs?.find((e: any) => e.env_name === envName);
    if (!project || !env) {
      this.configStore.setConnectError(`Environment "${envName}" of project "${projectName}" was not found or you have no access to it.`);
      return;
    }

    const service = env.public___project_services?.find(
      (s: ProjectServices) => s.service_name == this.configStore.currentService()
    );
    const baseUrl: string = service?.service_path || '';
    this.configStore.updateBaseUrl(baseUrl, service?.service_access || 'READ');
    this.configStore.updateProjectName(project.project_name);
    if (!baseUrl) {
      this.configStore.setConnectError(`${this.configStore.currentService()} has no URL configured for ${projectName} / ${envName}.`);
      return;
    }

    if (env.auth_user_name?.trim() && env.auth_user_password?.trim()) {
      const ok = await this.configStore.LoginWithUserPassword(
        env.login_url_path,
        env.auth_user_name,
        env.auth_user_password,
        env.auth_header_name,
        env.auth_header_value
      );
      if (!ok) return;
    } else {
      if (env.api_key_name?.trim() && env.api_key_value) {
        this.configStore.setApiKeyHeader(env.api_key_name, env.api_key_value);
      }
      this.configStore.setCanLoadConfig(true);
    }
    this.configStore.setMainLoaded(true);
  }

  retryConnect() {
    this.configStore.setConnectError('');
    this.connectStarted = false;
    const projects = this.projects();
    if (projects?.length) {
      this.processProjectsAndLogin(projects);
    } else {
      this.projectStore.fetchProjects(this.project(), this.env());
    }
  }

ngOnDestroy(): void {
  //this._mobileQuery.removeEventListener('change', this._mobileQueryListener);
  }
}

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}
